// extracted by mini-css-extract-plugin
export default {"customswitch":"customswitch_customswitch__yvE-5","revert":"customswitch_revert__4XHL2"};